import { Button } from "@mui/material";
import React from "react";

const baseButtonStyles = {
  fontWeight: "bold",
  borderRadius: 10,
  textTransform: "none",
  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  "&:active": {
    transform: "translateY(0)",
  },
};

export const PrimaryButton = ({
  children,
  type = "submit",
  fullWidth = true,
  variant = "contained",
  color = "primary",
  disabled = false,
  onClick,
  sx = {},
  ...props
}) => {
  const primaryButtonStyles = {
    ...baseButtonStyles,
    width: "100%",
  };

  return (
    <Button
      type={type}
      fullWidth={fullWidth}
      variant={variant}
      color={color}
      disabled={disabled}
      onClick={onClick}
      sx={{ ...primaryButtonStyles, ...sx }}
      {...props}
    >
      {children}
    </Button>
  );
};

export const SecondaryButton = ({
  children,
  type = "button",
  fullWidth = true,
  variant = "text",
  color = "black",
  disabled = false,
  onClick,
  sx = {},
  ...props
}) => {
  const secondaryButtonStyles = {
    ...baseButtonStyles,
    width: "fit-content",
    "&:hover": {
      borderWidth: 2,
      backgroundColor: "action.hover",
    },
  };

  return (
    <Button
      type={type}
      fullWidth={fullWidth}
      variant={variant}
      color={color}
      disabled={disabled}
      onClick={onClick}
      sx={{ ...secondaryButtonStyles, ...sx }}
      {...props}
    >
      {children}
    </Button>
  );
};
